import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import styled, { ThemeProvider } from 'styled-components';
import { theme } from '../../styles/theme';
import { GlobalStyle } from '../../styles/GlobalStyle';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { EnvironmentWatermark } from '../common/EnvironmentWatermark';
import { useGetUserProfileQuery } from '../../store/api/userApi';
import { updateUserProfile } from '../../store/slices/authSlice';

const LayoutContainer = styled.div`
  min-height: 100vh;
  background-color: ${props => props.theme.colors.gray[50]};
`;

const ContentWrapper = styled.div`
  margin-left: 16rem; // 64 * 0.25rem (256px)
  width: 100%;
  @media (max-width: 1024px) {
    margin-left: 0;
  }
`;

const Main = styled.main`
  padding: ${props => props.theme.spacing.xl} ${props => props.theme.spacing.md};
  
  margin: 0 auto;
  width: 100%;
  
  @media (min-width: 640px) {
    padding: ${props => props.theme.spacing.xl} ${props => props.theme.spacing.xl};
  }
  
  @media (min-width: 1024px) {
    padding: ${props => props.theme.spacing.xl} ${props => props.theme.spacing['2xl']};
  }
`;

export function Layout() {
  const dispatch = useDispatch();
  const { data: userProfile } = useGetUserProfileQuery();

  // Sync profile data to auth state when it loads
  useEffect(() => {
    if (userProfile) {
      dispatch(updateUserProfile({
        role: userProfile.role,
        hasClients: userProfile.hasClients,
      }));
    }
  }, [userProfile, dispatch]);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <LayoutContainer>
        <Header />
        <div style={{ display: 'flex' }}>
          <Sidebar />
          <ContentWrapper>
            <Main>
              <Outlet />
            </Main>
          </ContentWrapper>
        </div>
        <EnvironmentWatermark />
      </LayoutContainer>
    </ThemeProvider>
  );
}